{
  "aws_project_region": "us-east-2",
  "aws_appsync_graphqlEndpoint": "https://fdaufhhmbbgtffmis2dsc6seeu.appsync-api.us-east-2.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_apiKey": "da2-4ae7twr2xreexlqemqaklhokbe"
}